import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface NodeDeleteButtonProps {
  onClick: () => void;
  title?: string;
  className?: string;
  variant?: "default" | "hover-show";
}

export function NodeDeleteButton({ onClick, title = "删除", className, variant = "default" }: NodeDeleteButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={onClick}
      className={cn(
        "h-8 w-8 flex items-center justify-center rounded-md",
        "transition-colors hover:bg-destructive/10 hover:text-destructive",
        variant === "hover-show" && "opacity-0 group-hover:opacity-100",
        className,
      )}
      title={title}
    >
      <X className="h-4 w-4" />
    </Button>
  );
}
